import { put, takeEvery, call, select } from 'redux-saga/effects';
import service from '../../services';
import { setCurrentLayout, setMapInfo, setWebPageInfo } from '../layouts/actions';
import { transformCayugaData } from './utils';

// TODO
// Check if info already available don't send request

function* getLayoutInfo(action) {
  const {token} = yield select(state => state.API);
  const {id, name, entityType, shouldChangeLayout, activeViewPosition} = action;
  const {initialView} = yield select(state => state.layouts);
  const data = yield call(() => {
    switch (entityType) {
      case 'Layer':
        return service.requestLayerInfo(token, id);
      case 'Map':
        return service.requestMapInfo(token, id);
      case 'WebPage':
        return service.requestWebPageInfo(token, id);
      default:
        return [];
    }
  });

  if (!data.error) {
    switch (entityType) {
      case 'Layer':
        const res = transformCayugaData(data.data['a:GridElementInfo']);
        const transformedResult = {
          name,
          cameras: Array.isArray(res) ? Object.values(res).map(cam => {
            return {
              id: cam.id,
              type: cam.type,
              relative_position: {
                bottom: parseFloat(cam.height) + parseFloat(cam.y),
                right: parseFloat(cam.width) + parseFloat(cam.x),
                left: parseFloat(cam.x),
                top: parseFloat(cam.y)
              }
            }
          }) : [{
            id: res.id,
            type: res.type,
            relative_position: {
              bottom: parseFloat(res.height) + parseFloat(res.y),
              right: parseFloat(res.width) + parseFloat(res.x),
              left: parseFloat(res.x),
              top: parseFloat(res.y)
            }
          }]
        }
        yield put(setCurrentLayout({id, view: transformedResult, layoutType: entityType}, activeViewPosition));
        break;
      case 'Map':
        yield put(setMapInfo(data.data));
        if (shouldChangeLayout) {
          yield put(setCurrentLayout({
            id, view: {
              ...initialView,
              cameras: [{
                ...initialView.cameras[0],
                id,
                type: 'Map'
              }]
            }, layoutType: 'Map'
          }, activeViewPosition));
        }
        break;
      case 'WebPage':
        yield put(setWebPageInfo(data.data));
        if (shouldChangeLayout) {
          yield put(setCurrentLayout({
            id, view: {
              ...initialView,
              cameras: [{
                ...initialView.cameras[0],
                id,
                type: 'WebPage'
              }]
            }, layoutType: 'WebPage'
          }, activeViewPosition));
        }
        break;
      default:
        break;
    }
  }
}

export default function* () {
  yield takeEvery('getLayoutInfo', getLayoutInfo)
}